import Client from "./Client";
const client = new Client();
class SearchClient {
    get(uri) {
        return new Promise((resolve, reject) => {
            client.get(uri)
                .then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.statusText);
                }
            })
                .catch(error => {
                reject(error);
            });
        });
    }
}
export default new SearchClient;
